// extracted by mini-css-extract-plugin
module.exports = {"root":"TypingIndicator_root__3LFc1","typingIndicator":"TypingIndicator_typingIndicator__2Fext","loader":"TypingIndicator_loader__3La4u"};